import { render, staticRenderFns } from "./UserTabControl.vue?vue&type=template&id=9db2a722&"
import script from "./UserTabControl.vue?vue&type=script&lang=js&"
export * from "./UserTabControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports